
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTransformer02Off as ObiTransformer02OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-transformer-02-off.js';
 
 
 

 
 export const ObiTransformer02Off = createComponent({
   react: React,
   tagName: 'obi-transformer-02-off',
   elementClass: ObiTransformer02OffElement,
   events: {
     
   }
  });
 
 